import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.toggleBillingContactFields();
  }

  toggleBillingContactFields() {
    if (this.inputTarget.checked) {
      this.hideBillingContactFields();
    } else {
      this.showBillingContactFields();
    }
  }

  showBillingContactFields() {
    const billingContact = this.findBillingContactField();
    if (billingContact) {
      billingContact.style.display = "block";
    }
  }

  hideBillingContactFields() {
    const billingContact = this.findBillingContactField();
    if (billingContact) {
      billingContact.style.display = "none";
    }
  }

  findBillingContactField() {
    const billingContact = document.querySelector(".billing_contact");
    return billingContact;
  }
}
